import {User} from "./user";
import {GroupActivityCustomer} from "./GroupActivityCustomer";

export class GroupActivity {
    id?: string;
    trainer: User;
    participants: GroupActivityCustomer[];
}
